<!-- patient-measure-evidence-dialog.component.html -->
<div class="evidence-dialog-container">
  <!-- Loading spinner -->
  <div *ngIf="isLoading" class="loading-container">
    <mat-spinner diameter="40"></mat-spinner>
    <p>Loading measure evidence...</p>
  </div>

  <!-- Error message -->
  <div *ngIf="hasError" class="error-container">
    <mat-icon color="warn">error_outline</mat-icon>
    <p>{{ errorMessage }}</p>
    <button mat-raised-button color="primary" (click)="loadMeasureEvidence()">Retry</button>
  </div>

  <!-- emptyContent -->
  <div *ngIf="!isLoading && !hasError && !getEvidence()" class="no-evidence-content">
    <p>No Evidence To Display</p>
  </div>
  
  <!-- Evidence data display -->
  <div *ngIf="!isLoading && !hasError && getEvidence()" class="evidence-content">
    <div class="dialog-header">
      <h2>Measure Evidence Details</h2>
      <div class="header-actions">
        <button *ngIf="hasMultipleEvidence()" mat-icon-button class="nav-prev-btn" [disabled]="currentIndex === 0" (click)="previousEvidence()" color="primary" aria-label="Previous evidence">
      <mat-icon>navigate_before</mat-icon>
    </button>
        <!-- Added evidence counter -->
        <div *ngIf="hasMultipleEvidence()" class="evidence-counter unselectable">
          {{ currentIndex + 1 }} of {{ allEvidence.length }}
        </div>
          <button *ngIf="hasMultipleEvidence()" mat-icon-button class="nav-next-btn" [disabled]="currentIndex === allEvidence.length - 1" (click)="nextEvidence()" color="primary" aria-label="Next evidence">
      <mat-icon>navigate_next</mat-icon>
    </button>
        <button mat-icon-button (click)="closeDialog()" class="close-button">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
    
    <mat-divider></mat-divider>
    
    <div class="dialog-content">
      <div class="evidence-section">
        <h3 class="noMarginHeader">Patient Information</h3>
        <div class="patient-header">
          <p><strong>MRN:</strong> {{ getEvidence()?.patientMRN }}</p>
        </div>
        <div class="evidence-grid">
          <div class="evidence-item">
            <span class="label">Age:</span>
            <span class="value">{{ getEvidence()?.age }}</span>
          </div>
          <div class="evidence-item">
            <span class="label">Gender:</span>
            <span class="value">{{ getEvidence()?.gender }}</span>
          </div>
          <div class="evidence-item">
            <span class="label">EMR Encounter ID:</span>
            <span class="value">{{ getEvidence()?.emrEncounterID }}</span>
          </div>
          <div class="evidence-item">
            <span class="label">Encounter Date:</span>
            <span class="value">{{ getEvidence()?.encounterDate | date:'MM/dd/yyyy' }}</span>
          </div>
          <div class="evidence-item">
            <span class="label">Provider Name:</span>
            <span class="value">{{ getEvidence()?.providerFirstName + ' ' +  getEvidence()?.providerLastName}}</span>
          </div>
          <div class="evidence-item">
            <span class="label">Provider Location:</span>
            <span class="value">{{ getEvidence()?.serviceLocationName }}</span>
          </div>
        </div>
      </div>

      <mat-divider></mat-divider>

      <div class="evidence-section">
        <h3>Evidence Details</h3>
        <div class="evidence-grid">
          <div class="evidence-item">
            <span class="label">Component Code:</span>
            <span class="value">{{ getEvidence()?.componentCode }}</span>
          </div>
          <div class="evidence-item">
            <span class="label">Evidence Group Code:</span>
            <span class="value">{{ getEvidence()?.evidenceGroupCode || 'N/A' }}</span>
          </div>
          <div class="evidence-item">
            <span class="label">Evidence Type:</span>
            <span class="value">{{ getEvidence()?.evidenceType }}</span>
          </div>
          <div class="evidence-item">
            <span class="label">Code System Name:</span>
            <span class="value">{{ getEvidence()?.codeSystemName }}</span>
          </div>
          <div class="evidence-item">
            <span class="label">Code:</span>
            <span class="value">{{ getEvidence()?.code }}</span>
          </div>
               <div class="evidence-item">
            <span class="label">Modifier:</span>
            <span class="value">{{ getEvidence()?.modifier || 'N/A' }}</span>
          </div>
          <div class="evidence-item">
            <span class="label">Code Name:</span>
            <span class="value">{{ getEvidence()?.codeName }}</span>
          </div>
     
          <div class="evidence-item">
            <span class="label">Result Value:</span>
            <span class="value">{{ getEvidence()?.resultValue || 'N/A' }}</span>
          </div>
        </div>
      </div>

      <mat-divider></mat-divider>

      <div class="evidence-section">
        <h3>Reference Evidence</h3>
        <div class="evidence-grid">
          <div class="evidence-item">
            <span class="label">Reference Encounter Date:</span>
            <span class="value">{{ getEvidence()?.referenceEncounterDate | date:'MM/dd/yyyy' }}</span>
          </div>
          <div class="evidence-item">
            <span class="label">Reference Type:</span>
            <span class="value">{{ getRefTypeLabel(getEvidence()?.referenceEvidenceType) || 'N/A' }}</span>
          </div>
          <div class="evidence-item">
            <span class="label">Reference Code System:</span>
            <span class="value">{{ getEvidence()?.referenceCodeSystemName || 'N/A' }}</span>
          </div>
          <div class="evidence-item">
            <span class="label">Reference Code Name:</span>
            <span class="value">{{ getEvidence()?.referenceCodeName || 'N/A' }}</span>
          </div>
        
          <div class="evidence-item">
            <span class="label">Reference Code:</span>
            <span class="value">{{ getEvidence()?.referenceCode || 'N/A' }}</span>
          </div>
          <div class="evidence-item">
            <span class="label">Reference Modifier:</span>
            <span class="value">{{ getEvidence()?.referenceModifier || 'N/A' }}</span>
          </div>
          <div class="evidence-item">
            <span class="label">Reference Result Value:</span>
            <span class="value">{{ getEvidence()?.referenceResultValue || 'N/A' }}</span>
          </div>
        </div>
      </div>
    </div>


   
</div>
